import { useEffect, useState } from 'react';

import { Skeleton } from '@crehana/compass.ui/skeleton';

import { useTranslation } from '../i18n';
import { formatDateTime } from '../utils';
import { StatusLegend } from './status-legend';

type TDateTimeDisplayProps = {
  loading: boolean;
  timeZone: string;
};
export const DateTimeDisplay = ({
  loading,
  timeZone,
}: TDateTimeDisplayProps) => {
  if (loading) {
    return <DateSkeleton />;
  }

  return <DateTimeDisplayContent timeZone={timeZone} />;
};

const DateTimeDisplayContent = ({ timeZone }: { timeZone: string }) => {
  const { t, languageCode } = useTranslation();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    // update the time every minute
    const interval = setInterval(() => {
      setNow(new Date());
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const formattedDate = formatDateTime({
    isoDateStr: now.toISOString(),
    languageCode: languageCode,
    timeZone: timeZone,
  });

  return (
    <div className="tw-flex tw-items-center tw-gap-1.2">
      <div className="tw-flex tw-flex-col tw-gap-0.4">
        <span className="tw-cds-font-body-01 tw-cds-text-secondary">
          {t('timer_circle_today')}
        </span>

        <span className="tw-cds-font-subtitle-01 tw-cds-text-primary">
          {formattedDate.dateStr}
        </span>

        <span className="tw-cds-font-subtitle-01 tw-cds-text-primary">
          {formattedDate.timeStr}
        </span>
      </div>
      <StatusLegend />
    </div>
  );
};

const DateSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-col tw-gap-0.4">
      <span className="tw-cds-font-body-01 tw-cds-text-subtle">
        {t('date_time_display_today')}
      </span>
      <Skeleton className="tw-h-1.6 tw-w-20" />
      <Skeleton className="tw-h-1.6 tw-w-12" />
    </div>
  );
};
